export default "__VITE_ASSET__NCDGU$pa__"